export var DirectiveLocation = /*#__PURE__*/function (DirectiveLocation) {
  /** Request Definitions */
  DirectiveLocation["QUERY"] = "QUERY";
  DirectiveLocation["MUTATION"] = "MUTATION";
  DirectiveLocation["SUBSCRIPTION"] = "SUBSCRIPTION";
  DirectiveLocation["FIELD"] = "FIELD";
  DirectiveLocation["FRAGMENT_DEFINITION"] = "FRAGMENT_DEFINITION";
  DirectiveLocation["FRAGMENT_SPREAD"] = "FRAGMENT_SPREAD";
  DirectiveLocation["INLINE_FRAGMENT"] = "INLINE_FRAGMENT";
  DirectiveLocation["VARIABLE_DEFINITION"] = "VARIABLE_DEFINITION";
  /** Type System Definitions */
  DirectiveLocation["SCHEMA"] = "SCHEMA";
  DirectiveLocation["SCALAR"] = "SCALAR";
  DirectiveLocation["OBJECT"] = "OBJECT";
  DirectiveLocation["FIELD_DEFINITION"] = "FIELD_DEFINITION";
  DirectiveLocation["ARGUMENT_DEFINITION"] = "ARGUMENT_DEFINITION";
  DirectiveLocation["INTERFACE"] = "INTERFACE";
  DirectiveLocation["UNION"] = "UNION";
  DirectiveLocation["ENUM"] = "ENUM";
  DirectiveLocation["ENUM_VALUE"] = "ENUM_VALUE";
  DirectiveLocation["INPUT_OBJECT"] = "INPUT_OBJECT";
  DirectiveLocation["INPUT_FIELD_DEFINITION"] = "INPUT_FIELD_DEFINITION";
  return DirectiveLocation;
}(DirectiveLocation || {});